import { useResolvedTheme } from '../../lib/theme-context.tsx';

/**
 * The Fundline wordmark (brand/logo.md): ink letters in light mode, white letters in dark mode. Never
 * narrower than 120px; below that use the app icon.
 */
export function Logo({ width = 128 }: { width?: number }) {
  const theme = useResolvedTheme();
  const src =
    theme === 'dark' ? '/brand/fundline-wordmark-white.svg' : '/brand/fundline-wordmark.svg';
  return (
    <img
      src={src}
      alt="Fundline"
      width={Math.max(width, 120)}
      height={Math.round((Math.max(width, 120) * 378) / 1586)}
      className="block"
      data-testid="logo"
      data-theme-variant={theme}
    />
  );
}

/** The rounded app icon, for square or tiny spots (brand/logo.md "Which one to use"). */
export function AppIcon({ size = 32 }: { size?: number }) {
  return (
    <img src="/brand/fundline-app-icon-rounded.svg" alt="" width={size} height={size} aria-hidden />
  );
}
